<template>
    <div>
        <div class="row">

            <breadcrumb>
                <template v-slot:1>
                    <router-link :to="{ name: 'informes' }">{{
                        $t("informes")
                    }}</router-link>
                </template>
                <template v-slot:2>{{ $t("gastosPorSubproductos") }}</template>
            </breadcrumb>

            <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conBuscador="true"
                :textoExtra="$t('materiaPrima')"
                :textoExtraPlaceholder="$t('buscarPorNombreDeLaMateriaPrima')"
                :listElmExtra="listSubproduct"
                :emitirConsultaEnPadre="false"
                @consultar="getGastosSubproductos"
            />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <template v-else-if="respuesta">

                <div class="col-md-4 text-left" style="margin-bottom: 4px">
                    <el-select class="select-default filterTag"
                               size="large"
                               filterable
                               v-model="idFiltro"
                               data-is-search="true"
                               @change="getGastosSubproductos()"
                               placeholder="Filtrar por etiqueta">
                        <el-option v-for="tag in filterTag "
                                   class="select-primary"
                                   :value="tag.id"
                                   :label="tag.name"
                                   :key="tag.id">
                        </el-option>
                    </el-select>
                </div>
                <template v-if="listGastos.length> 0">
                    <div class="col-md-8 text-right">
                        <el-dropdown>
                            <el-button type="primary" size="small">
                                <i class="fa fa-file"></i>
                                {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <a :href="urlExportPDF">
                                    <el-dropdown-item class="text-danger">
                                        <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                    </el-dropdown-item>
                                </a>
                                <a :href="urlExportExcel">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                    </el-dropdown-item>
                                </a>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </template>

                <div class="col-md-12">
                    <template v-if="listGastos.length> 0">
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>
                                            <span v-if="ordenarProveedor"
                                                @click="sortedArrayASC(1),ordenarProveedor=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("proveedor")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(1), ordenarProveedor=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("proveedor")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarEtiqueta"
                                                @click="sortedArrayASC(2),ordenarEtiqueta=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("etiqueta")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(2), ordenarEtiqueta=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("etiqueta")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarCasa"
                                                @click="sortedArrayASC(3),ordenarCasa=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("casa")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(3), ordenarCasa=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("casa")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarCodEan"
                                                @click="sortedArrayASC(16),ordenarCodEan=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("codigoBarra")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(16), ordenarCodEan=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("codigoBarra")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarMateriaPrima"
                                                @click="sortedArrayASC(4),ordenarMateriaPrima=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("materiaPrima")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(4), ordenarMateriaPrima=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("materiaPrima")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarUnidades"
                                                @click="sortedArrayASC(5),ordenarUnidades=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("unidades")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(5), ordenarUnidades=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("unidades")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarPartes"
                                                @click="sortedArrayASC(6),ordenarPartes=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("partes")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(6), ordenarPartes=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("partes")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarImporte"
                                                @click="sortedArrayASC(7),ordenarImporte=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("base")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(7), ordenarImporte=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("base")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarImporte"
                                                @click="sortedArrayASC(7),ordenarImporte=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("importeConIva")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(7), ordenarImporte=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("importeConIva")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarPrecioMed"
                                                @click="sortedArrayASC(8),ordenarPrecioMed=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("precioMedSinIva")}}.
                                            </span>
                                            <span v-else @click="sortedArrayDESC(8), ordenarPrecioMed=1"><i
                                                    style="color: white" class="fa fa-angle-down"></i> {{$t("precioMedSinIva")}}.
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarUltimoPrecioCompra"
                                                @click="sortedArrayASC(17),ordenarUltimoPrecioCompra=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("ultimoPrecioCompra")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(17), ordenarUltimoPrecioCompra=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("ultimoPrecioCompra")}}
                                            </span>
                                        </th>
                                        <th>
                                            <span v-if="ordenarUltimoPrecioCompraSinIva"
                                                @click="sortedArrayASC(18),ordenarUltimoPrecioCompraSinIva=0"><i
                                                    style="color: white" class="fa fa-angle-up"></i> {{$t("ultimoPrecioCompraSinIva")}}
                                            </span>
                                            <span v-else @click="sortedArrayDESC(18), ordenarUltimoPrecioCompraSinIva=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("ultimoPrecioCompraSinIva")}}
                                            </span>
                                        </th>
                                        <th>
                                            {{$t('acciones')}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                
                                    <tr v-for="gas in listGastos">
                                        <td>
                                            <span v-if="gas.nameSupplier">{{gas.nameSupplier}}</span><span v-else>{{$t("sinProveedor")}}</span>
                                        </td>
                                        <td>
                                            <span v-if="gas.nameTag">{{gas.nameTag}}</span><span
                                                v-else>{{$t("sinCategoria")}}</span>
                                        </td>
                                        <td>
                                            <span v-if="gas.nameCasa">{{gas.nameCasa}}</span><span
                                                v-else>{{$t("sinCasas")}}</span>
                                        </td>
                                        <td>{{gas.codEan}}</td>
                                        <td>{{gas.name}}</td>
                                        <td>{{gas.ud}} {{gas.type}}</td>
                                        <td>{{gas.partes}}</td>
                                        <td align="right">
                                            {{gas.total | parseBase(gas.iva) | currency}}
                                        </td>
                                        <td align="right">
                                            {{gas.total | currency}}    
                                        </td>
                                        <td align="right">
                                            {{gas.coste | currency}}
                                        </td>
                                        <td align="right">
                                            {{gas.lastPrice | currency}}
                                        </td>
                                        <td align="right">
                                            {{gas.lastPriceSinIva | currency}}
                                        </td>
                                        <td align="center">
                                            <div @click="getFacturasByIdMateriaPrima(gas.idSupplierGasto,gas.idSubproduct), nameMateriaFactura=gas.name"
                                                class="btn btn-link">
                                                <i class="fas fa-list-ul text-primary"
                                                    style="cursor: pointer"
                                                    v-tooltip.top-center="'Ver desglose facturas'"
                                                ></i>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="table-success">
                                        <td><strong>{{$t("total")}}</strong></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        
                                        <td class="text-right"><strong>{{getBase | currency}}</strong></td>
                                        <td class="text-right"><strong>{{getTotal | currency}}</strong></td>
                                        <td class="text-right">
                                            <i
                                                v-tooltip.top-center="infoMedia"
                                                style="
                                                    white; 
                                                    padding:5px"
                                                class="fa fa-info-circle"
                                                >
                                            </i>
                                            <strong>{{getMedia | currency}}</strong>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <!--TOTAL ULTIMO PRECIO COMPRA-->
                                        <td></td>
                                    </tr>

                                </tbody>

                            </table>
                        </div>

                    </template>
                    <template v-else>

                        <div class="alert alert-danger" role="alert">
                            {{$t("noHay")}} <strong>{{$t("gastos")}}</strong> {{$t("rangoDeFechas")}}
                        </div>
                    </template>
                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{'disabled':pag == 1}">
                                        <router-link class="page-link"
                                                     :to="{name: 'gastos-materias-primas', params: {pag: pag-1}}"
                                                     v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{active : n == pag}">
                                        <router-link class="page-link"
                                                     :to="{name: 'gastos-materias-primas', params: {pag:n}}">{{n}}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{'disabled':pag == totalPags}">
                                        <router-link class="page-link"
                                                     :to="{name: 'gastos-materias-primas', params: {pag: nextPag}}"
                                                     v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </template>
        </div>

        <modal name="modal-ver-ref" :adaptive=true :scrollable=true height="auto" class="modalReferencia" :clickToClose=true>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">Referencias <span class="text-primary">{{nameMateriaFactura}} </span></h4>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        <span v-if="ordenarModFecha"
                                            @click="sortedArrayASC(9),ordenarModFecha=0"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("fecha")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(9), ordenarModFecha=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("fecha")}}
                                        </span>
                                    </th>
                                    <th>
                                        <span v-if="ordenarModReferencia"
                                            @click="sortedArrayASC(10),ordenarModReferencia=0"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("referencia")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(10), ordenarModReferencia=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("referencia")}}
                                        </span></th>
                                    <th> 
                                        <span v-if="ordenarModTipo"
                                            @click="sortedArrayASC(11),ordenarModTipo=0"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("tipo")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(11), ordenarModTipo=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("tipo")}}
                                        </span></th>
                                    <th>
                                        <span> {{$t("cantidad")}}</span>
                                    </th>
                                    <th> 
                                        <span v-if="ordenarModPrice"
                                            @click="sortedArrayASC(13),ordenarModPrice=0"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("precioUdSinIva")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(13), ordenarModPrice=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("precioUdSinIva")}}
                                        </span></th>
                                    <th> 
                                        <span v-if="ordenarModPrice"
                                            @click="sortedArrayASC(15),ordenarModDescuento=0"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("Descuento")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(15), ordenarModDescuento=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("Descuento")}}
                                        </span></th>
                                    <th> 
                                        <span v-if="ordenarModImporte"
                                            @click="sortedArrayASC(12),ordenarModImporte=0"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("importeSinIvaDto")}}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(12), ordenarModImporte=1"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{$t("importeSinIvaDto")}}
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="fac in listFacturas">
                                    <td>{{fac.date | parseDate}}</td>
                                    <td>
                                        {{fac.ref}}
                                        <i  v-if="fac.albaranFactura"
                                            v-tooltip.top-center="infoRef"
                                            style="
                                                white; 
                                                padding:5px"
                                            class="fa fa-info-circle"
                                        >
                                        </i>
                                    </td>
                                    <td>{{fac.type}}</td>
                                    <td>{{ fac.cantidad }}</td>
                                    <td>{{ fac.price | currency }}</td>
                                    <td>{{ fac.dto | currency }}</td>
                                    <td>
                                        <div
                                            v-if="fac.albaranFactura" 
                                            class="row" 
                                            style="padding-left:10px"
                                            @click.right.prevent 
                                            @copy.prevent
                                        >
                                            {{ fac.totalSinIVA | currency }}
                                            <i  v-if="fac.albaranFactura"
                                                v-tooltip.top-center="info"
                                                style="
                                                    white; 
                                                    padding:5px"
                                                class="fa fa-info-circle"
                                            >
                                            </i>
                                        </div>
                                        <div
                                            v-if="!fac.albaranFactura"
                                            class="row" 
                                            style="padding-left:10px"
                                        >
                                            {{ fac.totalSinIVA | currency }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><strong>{{getTotalFacturas | currency}}</strong></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>

                <div class="modal-footer">
                    <div class="col-md-8 text-right">
                        <el-dropdown>
                            <el-button type="primary" size="small; align-self: center">
                                <i class="fa fa-file"></i>
                                {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <a :href="urlExportExcelDetalles">
                                    <el-dropdown-item class="text-success">
                                        <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                    </el-dropdown-item>
                                </a>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <button @click="$modal.hide('modal-ver-ref')" class="btn btn-danger"><i
                                class="fas fa-arrow-circle-left"></i>
                            {{$t("volver")}}
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Loading, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
    import swal from 'sweetalert2'
    import moment from 'moment'
    import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
    import { mapState } from 'vuex'
    
    export default {
        created() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.$store.dispatch("setNameRoute", this.$i18n.t("gastosPorMateriasPrimas"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }
        },
        components: {
            CabeceraInformes,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            Breadcrumb
        },
        data() {
            return {
                //FILTRO
                filterTag: [],
                idFiltro: 0,

                listFacturas: [],
                nameMateriaFactura: "s",

                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                idBusiness: 0,
                listTpv: [],
                idsTpv: [],
                idTpv: 0,
                list: [],
                mode: 0,
                procedencia: 2,
                $Chart: null,
                objectChart: null,
                contador: 0,

                dividendoMedia: 0,

                listGastos: [],
                searchQuery: this.$route.params.query,
                isSearch: false,
                pag: this.$route.params.pag,
                totalPags: 0,

                idSubproducto: 0,
                idSubprod:0,
                idSupplyGasto:0,
                listSubproduct: [],

                //ORDENAR
                ordenarProveedor: 0,
                ordenarEtiqueta: 0,
                ordenarCasa: 0,
                ordenarMateriaPrima: 0,
                ordenarUnidades: 0,
                ordenarPartes: 0,
                ordenarImporte: 0,
                ordenarPrecioMed: 0,
                ordenarCodEan : 0,
                ordenarUltimoPrecioCompra:0,
                ordenarUltimoPrecioCompraSinIva: 0,
                //ORDENAR MODAL
                ordenarModFecha: 0,
                ordenarModReferencia: 0,
                ordenarModTipo: 0,
                ordenarModPrice: 0,
                ordenarModDescuento: 0,
                ordenarModImporte: 0,
                ordenarModImporteSinIVA: 0,

                respuesta: true,

                info: "Este importe no se suma al total ya que hace referencia a una factura derivada del mismo",
                infoRef:"Existe una factura derivada de este albaran",
                infoMedia:"Precio medio del total de unidades"
            }
        },
        watch: {
            '$route'(to, from) {
                if (to.params.pag) {
                    this.pag = to.params.pag;
                    this.getGastosSubproductos();
                } else if (to.params.query) {
                    this.query = to.params.query;
                    this.getGastosSubproductos();
                }
            }
        },
        computed: {
            ...mapState(["permiso"]),
            nextPag() {
                let nextPag = parseInt(this.pag) + 1;
                return nextPag;
            },

            urlExportPDF() {
                return this.$store.getters.apiUrl + "/subproducts/exportGastosSubproduct/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + this.idTpv + "&idSubproduct=" + this.idSubproducto + "&idFilter=" + this.idFiltro + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;
            },

            urlExportExcel() {
                return this.$store.getters.apiUrl + "/subproducts/exportGastosSubproduct/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + this.idTpv + "&idSubproduct=" + this.idSubproducto + "&idFilter=" + this.idFiltro + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;
            },

            urlExportExcelDetalles() {
                return this.$store.getters.apiUrl + "/subproducts/exportGastosSubproductDetalles?idBusiness=" + this.idBusiness + "&idSubproduct=" + this.idSubprod +"&idSupplierGasto=" + this.idSupplyGasto +"&nameReferencia=" + this.nameMateriaFactura + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;
            },

            showResult() {
                if (this.listGastos.length === 0) {
                    return this.$t('noEncontramosResultadosPara') + ' ' + this.searchQuery;
                } else {
                    const result = this.listGastos.length === 1 ? this.$t('resultado') : this.$t('resultados');
                    return this.$t('mostrando')+ " " + this.listGastos.length + " " + result;
                }
            },

            getTotal() {
                let total = 0;

                this.listGastos.forEach(function (d) {
                    if (d.partes > 0) {
                        total += d.total;
                    } else {
                        total += d.total;
                    }
                });

                return total;
            },
            /*
            getMedia() {


                let total = 0;
                this.dividendoMedia = this.listGastos.length

                this.listGastos.forEach(function (d) {
                    total += d.coste;
                });
                total = total / this.dividendoMedia;
                return total;
            },
            */
            getMedia(){
                let total = 0;
                let media = this.listGastos.length

                this.listGastos.forEach(function (d) {
                        total += d.coste;
                });

                total=total/media;

                return total;
            },
            getBase() {
                let total = 0;

                this.listGastos.forEach(function (d) {
                    if (d.partes > 0) {
                        total += (d.total /(1+d.iva/100));
                    } else {
                        total += (d.total)/(1+d.iva/100);
                    }
                });

                return total;
            },

            getTotalFacturas() {
                let xTotal = 0.0;

                this.listFacturas.forEach(function (x) {
                    if(!x.albaranFactura){
                        xTotal += x.totalSinIVA;
                    }
                });

                return xTotal;
            },
        },
        methods: {
            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdTpv", this.idTpv);
                let vm = this;

                this.axios.get(this.$store.getters.apiUrl + 'subproducts/getCategoryByTpv', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.filterTag = [];

                            if (response.data.result.length === 0) {
                                let category = {
                                    name: vm.$t('todos'),
                                    id: 0
                                };

                                vm.filterTag.push(category);
                            }

                            for (let i = 0; i < response.data.result.length; i++) {
                                if (i === 0) {
                                    let category = {
                                        name: vm.$t('todos'),
                                        id: 0
                                    };

                                    vm.filterTag.push(category);
                                }

                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                };

                                vm.filterTag.push(categoryname)
                            }
                        } else {
                            vm.loadingGeneral.close();
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    });
            },

            sortedArrayASC: function (nameAtributo) {
                switch (nameAtributo) {
                    case 1:
                        this.ordenarProveedor = 1;

                        function compareProveedor(a, b) {
                            if (a.nameSupplier.toUpperCase() < b.nameSupplier.toUpperCase())
                                return -1;
                            if (a.nameSupplier.toUpperCase() > b.nameSupplier.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareProveedor);

                    case 2:
                        this.ordenarEtiqueta = 1;

                        function compareEtiqueta(a, b) {
                            if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                                return -1;
                            if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareEtiqueta);

                    case 3:
                        this.ordenarCasa = 1;

                        function compareCasa(a, b) {
                            if (a.nameCasa.toUpperCase() < b.nameCasa.toUpperCase())
                                return -1;
                            if (a.nameCasa.toUpperCase() > b.nameCasa.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareCasa);

                    case 4:
                        this.ordenarMateriaPrima = 1;

                        function compareName(a, b) {
                            if (a.name < b.name)
                                return -1;
                            if (a.name > b.name)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareName);

                    case 5:
                        this.ordenarUnidades = 1;

                        function compareUnidades(a, b) {
                            if (a.ud < b.ud)
                                return -1;
                            if (a.ud > b.ud)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUnidades);

                    case 6:
                        this.ordenarPartes = 1;

                        function comparePartes(a, b) {
                            if (a.partes < b.partes)
                                return -1;
                            if (a.partes > b.partes)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(comparePartes);

                    case 7:
                        this.ordenarImporte = 1;

                        function compareImporte(a, b) {
                            if (a.coste * (a.ud + (a.partes - (a.partes % a.escandallo)) / a.escandallo) < b.coste * (b.ud + (b.partes - (b.partes % b.escandallo)) / b.escandallo))
                                return -1;
                            if (a.coste * (a.ud + (a.partes - (a.partes % a.escandallo)) / a.escandallo) > b.coste * (b.ud + (b.partes - (b.partes % b.escandallo)) / b.escandallo))
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareImporte);

                    case 8:
                        this.ordenarPrecioMed = 1;

                        function comparePrecioMed(a, b) {
                            if (a.coste * (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) / (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) < b.coste * (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo) / (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo))
                                return -1;

                            if (a.coste * (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) / (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) > b.coste * (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo) / (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo))
                                return 1;

                            return 0;
                        }

                        return this.listGastos.sort(comparePrecioMed);

                    case 9:
                        this.ordenarModFecha = 1;

                        function compareModFecha(a, b) {
                            if (a.date < b.date)
                                return -1;
                            if (a.date > b.date)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModFecha);

                    case 10:
                        this.ordenarModReferencia = 1;

                        function compareModReferencia(a, b) {
                            if (a.ref.toUpperCase() < b.ref.toUpperCase())
                                return -1;
                            if (a.ref.toUpperCase() > b.ref.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModReferencia);

                    case 11:
                        this.ordenarModTipo = 1;

                        function compareModTipo(a, b) {
                            if (a.type.toUpperCase() < b.type.toUpperCase())
                                return -1;
                            if (a.type.toUpperCase() > b.type.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModTipo);


                    case 12:
                        this.ordenarModImporte = 1;

                        function compareModImporte(a, b) {
                            if (a.total < b.total)
                                return -1;
                            if (a.total > b.total)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModImporte);

                    case 13:
                        this.ordenarModPrice = 1;

                        function compareModPrice(a, b) {
                            if (a.price < b.price)
                                return -1;
                            if (a.price > b.price)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModPrice);

                    case 14:
                        this.ordenarModImporteSinIVA = 1;

                        function compareModImporteSinIVA(a, b) {
                            if (a.totalSinIVA < b.totalSinIVA)
                                return -1;
                            if (a.totalSinIVA > b.totalSinIVA)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModImporteSinIVA);

                    case 15:
                        this.ordenarModImporteSinIVA = 1;

                        function compareModDescuento(a, b) {
                            if (a.dto < b.dto)
                                return -1;
                            if (a.dto > b.dto)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModDescuento);

                    case 16:
                        this.ordenarCodEan = 1;
                        
                        function compareCodEan(a, b){
                            if (a.codEan < b.codEan)
                                return -1;
                            if (a.codEan > b.codEan)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareCodEan);

                    case 17: 
                        this.ordenarUltimoPrecioCompra = 1;

                        function compareUltimoPrecio(a, b){
                            if (a.lastPrice < b.lastPrice)
                                return -1;
                            if (a.lastPrice > b.lastPrice)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUltimoPrecio);

                    case 18: 
                        this.ordenarUltimoPrecioCompraSinIva = 1;

                        function compareUltimoPrecioSinIva(a, b){
                            if (a.lastPriceSinIva < b.lastPriceSinIva)
                                return -1;
                            if (a.lastPriceSinIva > b.lastPriceSinIva)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUltimoPrecioSinIva);
                }

            },

            sortedArrayDESC: function (nameAtributo) {
                switch (nameAtributo) {
                    case 1:
                        this.ordenarProveedor = 0;

                        function compareProveedor(a, b) {
                            if (a.nameSupplier.toUpperCase() > b.nameSupplier.toUpperCase())
                                return -1;
                            if (a.nameSupplier.toUpperCase() < b.nameSupplier.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareProveedor);

                    case 2:
                        this.ordenarEtiqueta = 0;

                        function compareEtiqueta(a, b) {
                            if (a.nameTag.toUpperCase() > b.nameTag.toUpperCase())
                                return -1;
                            if (a.nameTag.toUpperCase() < b.nameTag.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareEtiqueta);

                    case 3:
                        this.ordenarCasa = 0;

                        function compareCasa(a, b) {
                            if (a.nameCasa.toUpperCase() > b.nameCasa.toUpperCase())
                                return -1;
                            if (a.nameCasa.toUpperCase() < b.nameCasa.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareCasa);

                    case 4:
                        this.ordenarMateriaPrima = 0;

                        function compareName(a, b) {
                            if (a.name > b.name)
                                return -1;
                            if (a.name < b.name)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareName);

                    case 5:
                        this.ordenarUnidades = 0;

                        function compareUnidades(a, b) {
                            if (a.ud > b.ud)
                                return -1;
                            if (a.ud < b.ud)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUnidades);

                    case 6:
                        this.ordenarPartes = 0;

                        function comparePartes(a, b) {
                            if (a.partes > b.partes)
                                return -1;
                            if (a.partes < b.partes)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(comparePartes);

                    case 7:
                        this.ordenarImporte = 0;

                        function compareImporte(a, b) {
                            if (a.coste * (a.ud + (a.partes - (a.partes % a.escandallo)) / a.escandallo) > b.coste * (b.ud + (b.partes - (b.partes % b.escandallo)) / b.escandallo))
                                return -1;
                            if (a.coste * (a.ud + (a.partes - (a.partes % a.escandallo)) / a.escandallo) < b.coste * (b.ud + (b.partes - (b.partes % b.escandallo)) / b.escandallo))
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareImporte);

                    case 8:
                        this.ordenarPrecioMed = 0;

                        function comparePrecioMed(a, b) {
                            if (a.coste * (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) / (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) > b.coste * (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo) / (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo))
                                return -1;

                            if (a.coste * (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) / (a.ud + (a.partes - (a.partes %
                                a.escandallo)) / a.escandallo) < b.coste * (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo) / (b.ud + (b.partes - (b.partes %
                                b.escandallo)) / b.escandallo))
                                return 1;

                            return 0;
                        }

                        return this.listGastos.sort(comparePrecioMed);

                    case 9:
                        this.ordenarModFecha = 0;

                        function compareModFecha(a, b) {
                            if (a.date > b.date)
                                return -1;
                            if (a.date < b.date)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModFecha);

                    case 10:
                        this.ordenarModReferencia = 0;

                        function compareModReferencia(a, b) {
                            if (a.ref.toUpperCase() > b.ref.toUpperCase())
                                return -1;
                            if (a.ref.toUpperCase() < b.ref.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModReferencia);

                    case 11:
                        this.ordenarModTipo = 0;

                        function compareModTipo(a, b) {
                            if (a.type.toUpperCase() > b.type.toUpperCase())
                                return -1;
                            if (a.type.toUpperCase() < b.type.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModTipo);

                    case 12:
                        this.ordenarModImporte = 0;

                        function compareModImporte(a, b) {
                            if (a.total > b.total)
                                return -1;
                            if (a.total < b.total)
                                return 1;
                            return 0;
                        }

                        return this.listFacturas.sort(compareModImporte);

                    case 16: 
                        this.ordenarCodEan = 0;

                        function compareCodEan(a, b){
                            if (a.codEan > b.codEan)
                                return -1;
                            if (a.codEan < b.codEan)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareCodEan);

                    case 17:
                        this.ordenarUltimoPrecioCompra = 0;

                        function compareUltimoPrecio(a, b){
                            if (a.lastPrice > b.lastPrice)
                                return -1;
                            if (a.lastPrice < b.lastPrice)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUltimoPrecio);
                    
                    case 18:
                        this.ordenarUltimoPrecioCompraSinIva = 0;

                        function compareUltimoPrecioSinIva(a, b){
                            if (a.lastPriceSinIva > b.lastPriceSinIva)
                                return -1;
                            if (a.lastPriceSinIva < b.lastPriceSinIva)
                                return 1;
                            return 0;
                        }

                        return this.listGastos.sort(compareUltimoPrecioSinIva);
                }
            },

            cambiarExtra(elem) {
                this.idSubproducto = elem;
            },

            searchCabecera(query) {
                this.searchSubproducto(query);
            },

            cambioBusiness(idBusinessData,listTpv) {
                this.loading = Loading.service({ text: "Cargando..." });
                this.idBusiness = idBusinessData;
                this.idTpv = listTpv[0].id;
                this.changeTPV();
                this.getGastosSubproductos();

                if (listTpv) {
                    this.listTpv = listTpv;
                }
            },

            emitirConsulta() {
                this.loading = Loading.service({ text: "Cargando..." });

                this.getGastosSubproductos();
            },

            cambioTpv(idTpvData, filtrar) {
                this.getCategory();

                if (idTpvData != undefined) {
                    this.idTpv = idTpvData;
                    this.mostrarTicket = false;
                    this.changeTPV();
                }
                
                this.idTpv=idTpvData;
            },

            cambioHora(dates) {
                if (dates) {
                    this.datefrom = dates[0];
                    this.dateto = dates[1];
                }
            },

            changeTPV() {
                this.idsTPV = [];
                this.idsTPV.push(this.idTpv);
                this.listGastos = [];
                this.getCategory();
            },

            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getTpv() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                }

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.filterTag = [];

                            vm.idFilter = "";

                            vm.idTpv = response.data.result[0].id;

                            for (let i = 0; i < response.data.result.length; i++) {
                                vm.idsTpv.push(response.data.result[i].id)
                            }

                            for (let i = 0; i < response.data.result.length; i++) {
                                let printername = {
                                    nameShow: response.data.result[i].nameShow,
                                    id: response.data.result[i].id
                                };

                                vm.listTpv.push(printername)
                            }

                            vm.getCategory();
                            vm.getGastosSubproductos();
                        } 
                        vm.loading.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            searchSubproducto(query) {
                if (query !== '') {
                    const controller = 'searchSubproductsByBusiness/' + query;

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.listSubproduct = [];

                                let xDate = {
                                    "id": 0,
                                    "name": vm.$t('todos'),
                                    "active" : 1
                                };

                                vm.listSubproduct.push(xDate);

                                response.data.result.listSubproduct.forEach(function (x) {
                                    let xDate = {
                                        "id": x.id,
                                        "name": x.name,
                                        "active": 1
                                    };

                                    vm.listSubproduct.push(xDate);
                                });

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },
   
            getGastosSubproductos() {
                this.dividendoMedia=0;
                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = Loading.service({ text: "Cargando..." });

                        if (this.idSubproducto === '') {
                            this.idSubproducto = 0;
                        }

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        const controller = this.searchQuery ? 'searchGastosSubproductsByBusiness/' + this.searchQuery : 'getGastosSubproduct';

                        var config = {
                            params: {
                                idFilter: this.idFiltro,
                                pag: this.pag,
                                idSubproduct: this.idSubproducto,
                                idBusiness: this.idBusiness,
                                idTpv: this.idTpv,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.$store.dispatch("setIdBusiness", this.idBusiness);
                        this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                            .then(function (response) {
                                vm.loading.close();

                                if (response.data.response) {
                                    vm.listGastos = response.data.result.gastosSubproduct;
                                    vm.pag = response.data.result.pag;
                                    vm.totalPags = response.data.result.totalPags;
                                    vm.respuesta = true;
                                    vm.getMedia();

                                } else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });

                                    vm.respuesta = false;
                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                    vm.respuesta = false;
                                }

                            })
                            .catch(function (error) {
                                console.log(error);
                            });

                        if (this.idSubproducto === 0) {

                            this.idSubproducto = 0;
                        }
                    }
                }
            },
            getFacturasByIdMateriaPrima(idSupplierGasto, idSubproduct) {
                const controller = 'getFacturasByIdMateriaPrima';

                this.idSupplyGasto = idSupplierGasto;
                this.idSubprod = idSubproduct;

                var config = {
                    params: {
                        idSubproduct: idSubproduct,
                        idSupplierGasto: idSupplierGasto,
                        idBusiness: this.idBusiness,
                        datefrom: moment(this.datefrom).startOf("day").unix(),
                        dateto: moment(this.dateto).endOf("day").unix(),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                    .then(function (response) {
                        vm.loading = false;

                        if (response.data.response) {
                            vm.listFacturas = response.data.result;
                            
                            vm.$modal.show("modal-ver-ref");

                            vm.respuesta = true;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.respuesta = false;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            removeSearch() {
                if (this.searchQuery && this.searchQuery !== "") {
                    this.searchQuery = "";
                    this.isSearch = false;
                    this.$router.push("/informes/subproductos/gastos-subproductos");
                    this.getGastosSubproductos();
                }
            },

            searchCasas() {
                if (this.searchQuery !== undefined && this.searchQuery !== "") {
                    this.$router.push({name: 'search-gastos-subproductos', params: {query: this.searchQuery}});
                    this.isSearch = true;
                }
            },
        },
    }
</script>
<style>
    .modalReferencia .v--modal-background-click .v--modal {
        width: 50% !important;
    }

    @media (max-width: 992px) {
        .modalReferencia .v--modal-background-click .v--modal {
            width: 100% !important;
        }
    }
</style>
<style scoped>
    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Subproductos/GastosSubproductos.vue